export function requireFastApiAccessToken(token: string | null | undefined) {
  if (!token) {
    throw new Error("FastAPI access token is missing");
  }

  return token;
}

export function getOptionalFastApiAccessToken(
  token: string | null | undefined,
) {
  return token ?? undefined;
}
